const messages = {
  fr: {
    suivant: 'Suivant',
    valider: 'Valider',
    multiselect_list_empty: 'Commencez à taper',
    champ_obligatoire: 'Champs obligatoires',
    blurry_document: 'Ce document nous semble flou. Si vous êtes sûr de sa netteté, vous pouvez continuer, sinon, nous vous conseillons d\'envoyer une autre image.',
    precedent: 'Précédent',
    merci_renseigner_adresse: 'Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
    votre_adresse: 'Votre Adresse *',
    changez_votre_adresse: 'Modifiez votre adresse',
    N_rue: 'Adresse, ligne 1',
    compl_addresse: "Complément d'adresse",
    ville: "Ville",
    code_postal: "Code postal",
    Madame: 'Madame',
    Numero_identification: 'Siren ou numéro DUNS *',
    Monsieur: 'Monsieur',
    'Corrigez les erreurs': 'Veuillez vérifier les erreurs restantes dans le formulaire.',
    trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
    trouvepasreparateur: 'Vous ne trouvez pas votre réparateur?',
    email_reparateur:'Email de votre réparateur *',
    enseigne_psa: 'Nom de la société *',
    VeeValidate: {
      attributes: {
        email: 'adresse mail',
        email_confirmation: 'confirmation de l\'adresse mail',
        full_name: 'nom complet',
        first_name: 'prénom',
        last_name: 'nom de famille',
        postcode: 'code postal',
        birthdate: 'date de naissance',
        buying_date: 'date d\'achat',
        date_max_today:'date',
        date_input:'date',
        phone: 'numéro de téléphone',
        mobile_phone: 'numéro de mobile',
        fixed_phone: 'numéro de téléphone fixe'
      },
      custom: {
        birthdate: {
          before: 'Vous devez être majeur'
        },
        ean: {
          regex: 'Votre code-barres doit comporter 13 chiffres'
        },
        siret: {
          regex: 'Le SIRET doit être composé de 14 chiffres'
        },
        email: {
          unique: 'Cette adresse email est déjà enregistrée. Cette opération est limitée à une seule participation par foyer',
        },
        siren: {
          regex: 'Le SIREN doit être composé de 9 chiffres'
        },
        confirm: {
          required:'Ce champ est obligatoire'
        },
        marketing1: {
          required:'Ce champ est obligatoire'
        },
        marketing2: {
          required:'Ce champ est obligatoire'
        },
        Iban: {
          iban: "Ce IBAN est invalide",
          countryiban: "Les IBAN de ce pays ne sont pas acceptés"
        },
        date_max_today: {
          date_min:"Cette date ne peut être antérieure au début de l'opération",
          required:'Ce champ est obligatoire'
        }
      }
    }
  },
  uk: {
    suivant: 'Next',
    valider: 'Submit',
    champ_obligatoire: 'Required fields',
    multiselect_list_empty: 'Start typing',
    precedent: 'Previous',
    merci_renseigner_adresse: 'Please select a suggested address or click on "I can\'t find my address"',
    trouvepasadresse: 'I can\'t find my address',
    trouvepasreparateur: 'You can\'t find it?',
    email_reparateur:'E-mail of your repairer *',
    enseigne_psa: 'Company name *',
    Numero_identification: 'DUNS number *',
    votre_adresse: 'Your address *',
    changez_votre_adresse: 'Edit your address',
    N_rue: 'Number and street name',
    compl_addresse: "Additional address info",
    ville: "City",
    code_postal: "ZIP code",
    Madame: 'Mrs.',
    Monsieur: 'Mr.',
    VeeValidate: {
      attributes: {
        email: 'e-mail',
        email_confirmation: 'confirm your e-mail',
        full_name: 'first and last name',
        first_name: 'first name',
        last_name: 'last name ',
        postcode: 'ZIP code',
        birthdate: 'birthdate',
        buying_date: 'buying date',
        date_max_today:'date',
        date_input:'date',
        phone: 'phone number',
        mobile_phone: 'mobile phone number',
        fixed_phone: 'landline phone number '
      },
      custom: {
        birthdate: {
          before: 'You must be of legal age'
        },
        date_max_today: {
          date_min:"This date can't be anterior to the start of this promotion"
        }
      }
    }
  },
  "es-es": {
    suivant: 'próximo',
    valider: 'Validar',
    champ_obligatoire: 'campos obligatorios',
    precedent: 'anterior',
    merci_renseigner_adresse: 'Introduzca su dirección o haga clic en "No encuentro mi dirección"',
    votre_adresse: 'Tu dirección *',
    changez_votre_adresse: 'Cambie tu dirección',
    Numero_identification: 'TO_TRANSLATE_ES D.U.N.S number *',
    N_rue: 'Número y nombre de la calle',
    compl_addresse: "Información de dirección adicional",
    ville: "Ciudad",
    code_postal: "Código postal",
    Madame: 'Señor',
    Monsieur: 'Señora',
    trouvepasadresse: 'Não consegue encontrar o seu endereço',
    'Corrigez les erreurs': 'Compruebe si hay errores en el formulario',
    trouvepasreparateur: 'TO_TRANSLATE_ES_REPARATOR?',
    enseigne_psa: 'TO_TRANSLATE_ES_ENSEIGNE',
    email_reparateur:'TO_TRANSLATE_ES_E-mail of your repairer *',
    VeeValidate: {
      attributes: {
        email: 'Correo electrónico',
        email_confirmation: 'TO_TRANSLATE_ES confirmation de l\'adresse mail',
        full_name: 'TO_TRANSLATE_ES nom complet',
        first_name: 'Nombre',
        last_name: 'Apellido/s',
        postcode: 'Código postal',
        birthdate: 'TO_TRANSLATE_ES date de naissance',
        buying_date: 'TO_TRANSLATE_ES date d\'achat',
        date_max_today:'date',
        date_input:'date',
        phone: 'TO_TRANSLATE_ES numéro de téléphone',
        mobile_phone: 'TO_TRANSLATE_ES numéro de mobile',
        fixed_phone: 'TO_TRANSLATE_ES numéro de téléphone fixe'
      },
      custom: {
        birthdate: {
          before: 'TO_TRANSLATE_ES Vous devez être majeur'
        },
        date_max_today: {
          date_min:"TO_TRANSLATE_ES_This date can't be anterior to the start of this promotion"
        }
      }
    }
  },
  "es-cat": {
    suivant: 'Próximo',
    valider: 'ubmitos',
    champ_obligatoire: 'TO_TRANSLATE_ES CHAMPOS OBLIGANDO',
    precedent: 'TO_TRANSLATE_ES PRECEDENTOS',
    merci_renseigner_adresse: 'TO_TRANSLATE_ES Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
    votre_adresse: 'Adreça *',
    N_rue: 'Carrer i número de casa',
    compl_addresse: "Informació addicional sobre l'adreça",
    ville: "TO_TRANSLATE_ES Ville",
    code_postal: "TO_TRANSLATE_ES Code postal",
    Numero_identification: 'TO_TRANSLATE_ES_D.U.N.S number *',
    Madame: 'TO_TRANSLATE_ES Madame',
    Monsieur: 'TO_TRANSLATE_ES Monsieur',
    trouvepasreparateur: 'TO_TRANSLATE_CAT_REPARATOR?',
    'Corrigez les erreurs': 'Compruebe si hay errores en el formulario',
    email_reparateur:'TO_TRANSLATE_CAT_E-mail of your repairer *',
    enseigne_psa: 'TO_TRANSLATE_CAT_ENSEIGNE',
    VeeValidate: {
      attributes: {
        email: 'TO_TRANSLATE_ES adresse mail',
        email_confirmation: 'TO_TRANSLATE_ES confirmation de l\'adresse mail',
        full_name: 'TO_TRANSLATE_ES nom complet',
        first_name: 'TO_TRANSLATE_ES prénom',
        last_name: 'TO_TRANSLATE_ES nom de famille',
        postcode: 'TO_TRANSLATE_ES code postal',
        birthdate: 'TO_TRANSLATE_ES date de naissance',
        buying_date: 'TO_TRANSLATE_ES date d\'achat',
        date_max_today:'date',
        date_input:'date',
        phone: 'TO_TRANSLATE_ES numéro de téléphone',
        mobile_phone: 'TO_TRANSLATE_ES numéro de mobile',
        fixed_phone: 'TO_TRANSLATE_ES numéro de téléphone fixe'
      },
      custom: {
        birthdate: {
          before: 'TO_TRANSLATE_ES Vous devez être majeur'
        },
        date_max_today: {
          date_min:"TO_TRANSLATE_CAT_This date can't be anterior to the start of this promotion"
        }
      }
    }
  },
  de: {
    suivant: 'Weiter',
    valider: 'validate',
    champ_obligatoire: 'Pflichtangabe',
    multiselect_list_empty: 'Mit der Eingabe beginnen',
    precedent: 'zurück',
    blurry_document:'Dieses Dokument scheint unscharf zu sein. Wir empfehlen Ihnen, ein anderes Bild zu senden, um zu vermeiden, dass die Bewerbung abgelehnt wird.',
    merci_renseigner_adresse: 'Bitte geben Sie Ihre Adresse ein, oder klicken Sie auf "Ich kann meine Adresse nicht finden".',
    votre_adresse: 'Ihre Adresse *',
    changez_votre_adresse: 'Ändern Sie Ihre Adresse',
    N_rue: 'Strasse und Hausnummer *',
    compl_addresse: "Adresszusatz",
    Numero_identification: 'Identifikationsnummer*',
    ville: "Ort",
    code_postal: "Postleitzahl",
    Madame: 'Frau',
    Monsieur: 'Herr',
    trouvepasadresse: ' Sie finden Ihre Adresse nicht?',
    'Corrigez les erreurs': 'Bitte überprüfen Sie Ihre eingabe.',
    trouvepasreparateur: 'Sie finden Ihre reparatur nicht?',
    email_reparateur:'E-Mail Adresse *',
    enseigne_psa: 'Firmenamme *',
    VeeValidate: {
      attributes: {
        email: 'E-mail',
        email_confirmation: 'E-Mail-Adresse und Bestätigung stimmen nicht überein',
        full_name: 'Name und Vorname',
        first_name: 'Vorname',
        last_name: 'Nachname',
        postcode: 'Postleitzahl',
        birthdate: 'Geburtstag',
        buying_date: 'Kaufdatum',
        date_max_today:'Datum',
        date_input:'Datum',
        phone: 'Telefonnummer',
        mobile_phone: 'Handynummer',
        fixed_phone: 'Festnetznummer'
      },
      custom: {
        birthdate: {
          before: 'Sie müssen volljährig sein'
        },
        date_max_today: {
          date_min:"Dieses Datum darf nicht vor dem Start dieses Vorgangs liegen.",
          required:'Dieses Feld ist obligatorisch'
        },
        Iban: {
          iban: "Deze IBAN is Diese IBAN ist ungültig",
          countryiban: "IBANs aus diesem Land werden nicht akzeptiert"
        },
        email: {
          unique: 'Dit e-mailadres is al geregistreerd. Deze actie is beperkt tot 1 inzendingen per huishouden',
        },
        confirm: {
          required:'Dieses Feld ist obligatorisch'
        },
        marketing1: {
          required:'Dieses Feld ist obligatorisch'
        },
        marketing2: {
          required:'Dieses Feld ist obligatorisch'
        }
      }
    }
  },
  nl: {
    suivant: 'volgend',
    valider: 'bevestigen',
    multiselect_list_empty:'Begin met typen',
    champ_obligatoire: 'verplichte velden',
    blurry_document:'Dit document ziet er wazig uit, wij adviseren u een andere afbeelding te sturen om te voorkomen dat het bestand wordt geweigerd.',
    precedent: 'vorig',
    merci_renseigner_adresse: 'Voer alstublieft uw adres in, of klik op "Ik kan mijn adres niet vinden"',
    votre_adresse: 'Uw adres *',
    changez_votre_adresse:'Uw adres wijzigen',
    N_rue: 'Straatnaam en huisnummer',
    compl_addresse: "Aanvullende adresinformatie",
    ville: "Stad",
    code_postal: "Postcode",
    Madame: 'Mevr',
    Monsieur: 'Man',
    'Corrigez les erreurs':'Controleer de resterende fouten in het formulier.',
    Numero_identification: 'D.U.N.S nummer * (Identificatienummer)',
    trouvepasadresse: 'Staat uw adres er niet bij?',
    trouvepasreparateur: 'Ik kan mijn reparateur niet vinden?',
    email_reparateur:'Reparateur email *',
    enseigne_psa: 'bedrijfsnaam *',
    VeeValidate: {
      attributes: {
        email: 'Email',
        email_confirmation: 'Bevestig je email',
        full_name: 'Voor- en achternaam',
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        postcode: 'Postcode',
        birthdate: 'Geboortedatum',
        buying_date: 'Aankoopdatum',
        date_max_today:'Datum',
        date_input:'Datum',
        phone: 'Telefoonnummer',
        mobile_phone: 'Mobiele telefoonnummer',
        fixed_phone: 'Vast telefoonnummer'
      },
      custom: {
        birthdate: {
          before: 'Je moet de wettelijke leeftijd hebben'
        },
        date_max_today: {
          date_min:"Dieses Datum darf nicht vor dem Start dieses Vorgangs liegen."
        },
        Iban: {
          iban: "Deze IBAN is ongeldig",
          countryiban: "IBAN's uit dit land worden niet geaccepteerd"
        },
        email: {
          unique: 'Dit e-mailadres is al geregistreerd. Deze actie is beperkt tot 1 inzendingen per huishouden',
        },
        confirm: {
          required:'Dit veld is verplicht'
        },
        marketing1: {
          required:'Dit veld is verplicht'
        },
        marketing2: {
          required:'Dit veld is verplicht'
        }
      }
    }
  },
  "lu-fr": {
    suivant: 'Suivant',
    valider: 'Valider',
    champ_obligatoire: 'Champ obligatoire',
    precedent: 'Précédent',
    merci_renseigner_adresse: 'Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
    votre_adresse: 'Votre Adresse *',
    N_rue: 'N°, rue',
    compl_addresse: "Complément d'adresse",
    ville: "Ville",
    Numero_identification: 'Numéro D.U.N.S *',
    code_postal: "Code postal *",
    Madame: 'Madame',
    Monsieur: 'Monsieur',
    trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
    email_reparateur:'email de votre réparateur *',
    enseigne_psa: 'Nom de la société *',
    VeeValidate: {
      attributes: {
        email: 'adresse mail',
        email_confirmation: 'confirmation de l\'adresse mail',
        full_name: 'nom complet',
        first_name: 'prénom',
        last_name: 'nom de famille',
        postcode: 'code postal',
        birthdate: 'date de naissance',
        buying_date: 'date d\'achat',
        date_max_today:'date',
        date_input:'date',
        phone: 'numéro de téléphone',
        mobile_phone: 'numéro de mobile',
        fixed_phone: 'numéro de téléphone fixe'
      },
      custom: {
        birthdate: {
          before: 'Vous devez être majeur'
        },
        date_max_today: {
          date_min:"Cette date ne peut être antérieure au début de l'opération",
          required:'Ce champ est obligatoire'
        }
      }
    }
  },
  "lu-nl": {
    suivant: 'volgend',
    valider: 'bevestigen',
    champ_obligatoire: 'verplichte velden',
    precedent: 'vorig',
    merci_renseigner_adresse: 'Voer alstublieft uw adres in, of klik op "Ik kan mijn adres niet vinden"',
    votre_adresse: 'Jouw adres *',
    N_rue: 'Straat en huisnummer',
    compl_addresse: "Aanvullende adresgegevens",
    ville: "Stad",
    code_postal: "Postcode",
    Madame: 'Mevr',
    Monsieur: 'Man',
    Numero_identification: 'D.U.N.S nummer *',
    trouvepasadresse: 'Vind je je adres niet ?',
    trouvepasreparateur: 'Ik kan mijn reparateur niet vinden?',
    email_reparateur:'Reparateur e-mail*',
    enseigne_psa: 'bedrijfsnaam *',
    VeeValidate: {
      attributes: {
        email: 'Email',
        email_confirmation: 'Bevestig je email',
        full_name: 'Voor- en achternaam',
        first_name: 'Voornaam',
        last_name: 'Achternaam',
        postcode: 'Postcode',
        birthdate: 'Geboortedatum',
        buying_date: 'Aankoopdatum',
        date_max_today:'Datum',
        date_input:'Datum',
        phone: 'Telefoonnummer',
        mobile_phone: 'Mobiele telefoonnummer',
        fixed_phone: 'Vast telefoonnummer'
      },
      custom: {
        birthdate: {
          before: 'Je moet de wettelijke leeftijd hebben'
        },
        date_max_today: {
          date_min:"Deze datum kan niet vroeger zijn dan de start van deze bewerking"
        }

      }
    }
  },
  "be-fr": {
    suivant: 'Suivant',
    valider: 'Valider',
    champ_obligatoire: 'Champ obligatoire',
    precedent: 'Précédent',
    merci_renseigner_adresse: 'Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
    votre_adresse: 'Votre Adresse *',
    N_rue: 'N°, rue',
    compl_addresse: "Complément d'adresse",
    ville: "Ville",
    code_postal: "Code postal",
    Madame: 'Madame',
    Monsieur: 'Monsieur',
    trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
    enseigne_psa: 'Nom de la société * ',
    Numero_identification: 'numéro DUNS *',
    email_reparateur:'Email de votre réparateur *',
    VeeValidate: {
      attributes: {
        email: 'adresse mail',
        email_confirmation: 'confirmation de l\'adresse mail',
        full_name: 'nom complet',
        first_name: 'prénom',
        last_name: 'nom de famille',
        postcode: 'code postal',
        birthdate: 'date de naissance',
        buying_date: 'date d\'achat',
        date_max_today:'date',
        date_input:'date',
        phone: 'numéro de téléphone',
        mobile_phone: 'numéro de mobile',
        fixed_phone: 'numéro de téléphone fixe'
      },
      custom: {
        birthdate: {
          before: 'Vous devez être majeur'
        },
        date_max_today: {
          date_min:"Cette date ne peut être antérieure au début de l'opération",
          required:'Ce champ est obligatoire'
        }
      }
    }
  },
  "be-nl": {
    suivant: 'volgend',
    valider: 'bevestigen',
    champ_obligatoire: 'verplichte velden',
    multiselect_list_empty: 'Begin met typen',
    blurry_document: 'Dit document ziet er wazig uit, wij adviseren u een andere afbeelding te sturen om te voorkomen dat het bestand wordt geweigerd.',
    precedent: 'vorig',
    merci_renseigner_adresse: 'Voer alstublieft uw adres in, of klik op "Ik kan mijn adres niet vinden"',
    votre_adresse: 'Uw adres *',
    'modifier votre adresse':'Uw adres wijzigen',
    N_rue: 'Straatnaam en huisnummer',
    compl_addresse: "Aanvullende adresgegevens",
    trouvepasreparateur: 'Ik kan mijn reparateur niet vinden?',
    enseigne_psa: 'bedrijfsnaam *',
    ville: "Plaats",
    code_postal: "Postcode",
    Numero_identification: 'D.U.N.S nummer *',
    Madame: 'Mevr',
    Monsieur: 'Man',
    trouvepasadresse: 'Vind je je adres niet ?',
    email_reparateur:'Reparateur e-mail*',
    VeeValidate: {
      attributes: {
        email: 'E-mail',
        email_confirmation: 'Bevestig je email',
        full_name: 'Voor- en achternaam',
        first_name: 'Voornaam',
        last_name: 'Naam',
        postcode: 'Postcode',
        birthdate: 'Geboortedatum',
        buying_date: 'Aankoopdatum',
        date_max_today:'Datum',
        date_input:'Datum',
        phone: 'Telefoon',
        mobile_phone: 'Mobiele telefoon',
        fixed_phone: 'Vast telefoon'
      },
      custom: {
        birthdate: {
          before: 'Je moet de wettelijke leeftijd hebben'
        },
        confirm: {
          required:'Dit veld is verplicht'
        },
        marketing1: {
          required:'Dit veld is verplicht'
        },
        marketing2: {
          required:'Dit veld is verplicht'
        },
        Iban: {
          iban: "Deze IBAN is ongeldig",
          countryiban: "IBAN's uit dit land worden niet geaccepteerd"
        },
        date_max_today: {
          date_min:"Dieses Datum darf nicht vor dem Start dieses Vorgangs liegen.",
          required:'Dit veld is verplicht'
        }
      }
    }
  },
  sl: {
    suivant: 'TO_TRANSLATE_SL Suivant',
    valider: 'TO_TRANSLATE_SL Valider',
    champ_obligatoire: 'obvezna polja',
    precedent: 'TO_TRANSLATE_SL Précédent',
    merci_renseigner_adresse: 'Vnesite svoj naslov ali pa kliknite možnost »Ne najdem svojega naslova«',
    votre_adresse: 'POŠTNI NASLOV *',
    N_rue: 'Številka ulice',
    compl_addresse: "Dodatni naslov",
    ville: "Kraj",
    code_postal: "Poštna številka",
    Madame: 'Gospa',
    Monsieur: 'Gospod',
    Numero_identification: 'TO_TRANSLATE_SL_D.U.N.S nummer *',
    trouvepasadresse: 'Ne najdem svojega naslova',
    trouvepasreparateur: 'TO_TRANSLATE_SL_REPARATOR?',
    enseigne_psa: 'TO_TRANSLATE_SL_ENSEIGNE',
    email_reparateur:'TO_TRANSLATE_SL_Email de votre réparateur *',
    VeeValidate: {
      attributes: {
        email: 'E-POŠTA',
        email_confirmation: 'TO_TRANSLATE_SL_confirmation de l\'adresse mail',
        full_name: 'TO_TRANSLATE_SL_nom complet',
        first_name: 'IME',
        last_name: 'PRIIMEK',
        postcode: 'Poštna številka',
        birthdate: 'DATUM ROJSTVA',
        buying_date: 'TO_TRANSLATE_SL_date d\'achat',
        date_max_today:'DATUM',
        date_input:'DATUM',
        phone: 'TELEFON',
        mobile_phone: 'MOBILNI TELEFON',
        fixed_phone: 'STACIONARNI TELEFON'
      },
      custom: {
        birthdate: {
          before: 'Vous devez être majeur'
        },
        date_max_today: {
          date_min:"TO_TRANSLATE_SL_Deze datum kan niet vroeger zijn dan de start van deze bewerking",
        }
      }
    }
  },
  bg: {
    suivant: 'TO_TRANSLATE_BG Suivant',
    valider: 'TO_TRANSLATE_BG Valider',
    champ_obligatoire: 'задължителни полета',
    precedent: 'TO_TRANSLATE_BG Précédent',
    merci_renseigner_adresse: 'Моля, попълнете адреса си или щракнете върху „Не намирам адреса си“',
    votre_adresse: 'ПОЩЕНСКИ АДРЕС *',
    N_rue: 'Улица, №',
    compl_addresse: "Други адресни данни",
    ville: "Град",
    code_postal: "Пощенски код",
    Madame: 'Gospa',
    Monsieur: 'Gospod',
    Numero_identification: 'TO_TRANSLATE_BG_D.U.N.S nummer *',
    trouvepasadresse: 'Не намирате адреса си?',
    trouvepasreparateur: 'TO_TRANSLATE_BG_REPARATOR?',
    enseigne_psa: 'TO_TRANSLATE_BG_ENSEIGNE',
    email_reparateur:'TO_TRANSLATE_BG_Email de votre réparateur *',
    VeeValidate: {
      attributes: {
        email: 'ИМЕЙЛ',
        email_confirmation: 'TO_TRANSLATE_BG_confirmation de l\'adresse mail',
        full_name: 'TO_TRANSLATE_BG_nom complet',
        first_name: 'СОБСТВЕНО ИМЕ',
        last_name: 'ФАМИЛНО ИМЕ',
        postcode: 'Пощенски код',
        birthdate: 'ДАТА НА РАЖДАНЕ',
        buying_date: 'TO_TRANSLATE_BG_date d\'achat',
        date_max_today:'ДАТА',
        date_input:'ДАТА',
        phone: 'ТЕЛЕФОН',
        mobile_phone: 'ТЕЛЕФОНЕН НОМЕР',
        fixed_phone: 'ДОМАШЕН ТЕЛЕФОНЕН НОМЕР'
      },
      custom: {
        birthdate: {
          before: 'Vous devez être majeur'
        },
        date_max_today: {
          date_min:"TO_TRANSLATE_BG_Deze datum kan niet vroeger zijn dan de start van deze bewerking",
        }
      }
    }
  },
  ro: {
    suivant: 'TO_TRANSLATE_RO Suivant',
    valider: 'TO_TRANSLATE_RO Valider',
    champ_obligatoire: 'câmpuri obligatorii',
    precedent: 'TO_TRANSLATE_RO Précédent',
    merci_renseigner_adresse: 'Vă rugăm să completați adresa dvs. sau să faceți clic pe „Nu îmi găsesc adresa”',
    votre_adresse: 'ADRESA *',
    N_rue: 'Număr Stradă',
    compl_addresse: "Alte detalii privind adresa",
    ville: "Oraș",
    code_postal: "Cod poștal",
    Madame: 'Doamna',
    Monsieur: 'Domnul',
    Numero_identification: 'TO_TRANSLATE_RO_D.U.N.S nummer *',
    trouvepasadresse: 'Nu vă puteți găsi adresa?',
    trouvepasreparateur: 'TO_TRANSLATE_RO_REPARATOR?',
    enseigne_psa: 'TO_TRANSLATE_RO_ENSEIGNE',
    email_reparateur:'TO_TRANSLATE_RO_Email de votre réparateur *',
    VeeValidate: {
      attributes: {
        email: 'E-MAIL',
        email_confirmation: 'TO_TRANSLATE_RO_confirmation de l\'adresse mail',
        full_name: 'TO_TRANSLATE_RO_nom complet',
        first_name: 'PRENUME',
        last_name: 'NUME',
        postcode: 'Cod poștal',
        birthdate: 'DATA NAȘTERII',
        buying_date: 'TO_TRANSLATE_RO_date d\'achat',
        date_max_today:'DATA',
        date_input:'DATA',
        phone: 'TELEFON',
        mobile_phone: 'TELEFON MOBIL',
        fixed_phone: 'TELEFON FIX'
      },
      custom: {
        birthdate: {
          before: 'Vous devez être majeur'
        },
        date_max_today: {
          date_min:"TO_TRANSLATE_RO_Deze datum kan niet vroeger zijn dan de start van deze bewerking",
        }
      }
    }
  },
  el: {
    suivant: 'TO_TRANSLATE_RO Suivant',
    valider: 'TO_TRANSLATE_RO Valider',
    champ_obligatoire: 'Υποχρεωτικό πεδίο',
    precedent: 'TO_TRANSLATE_RO Précédent',
    merci_renseigner_adresse: 'Συμπληρώστε τη διεύθυνσή σας ή κάντε κλικ στο "Δεν μπορώ να βρω τη διεύθυνσή μου"',
    votre_adresse: 'ΤΑΧ/ΚΗ ΔΙΕΥΘΥΝΣΗ *',
    N_rue: 'Οδός και αριθμός',
    compl_addresse: "Λοιπά στοιχεία διεύθυνσης",
    ville: "Πόλη",
    code_postal: "Ταχυδρομικός κώδικας",
    Madame: 'κυρία',
    Monsieur: 'κύριος',
    Numero_identification: 'TO_TRANSLATE_RO_D.U.N.S nummer *',
    trouvepasadresse: 'Δεν μπορείτε να βρείτε τη διεύθυνσή σας;',
    trouvepasreparateur: 'TO_TRANSLATE_RO_REPARATOR?',
    enseigne_psa: 'TO_TRANSLATE_RO_ENSEIGNE',
    email_reparateur:'TO_TRANSLATE_RO_Email de votre réparateur *',
    VeeValidate: {
      attributes: {
        email: 'EMAIL',
        email_confirmation: 'TO_TRANSLATE_RO_confirmation de l\'adresse mail',
        full_name: 'TO_TRANSLATE_RO_nom complet',
        first_name: 'ΌΝΟΜΑ',
        last_name: 'ΕΠΩΝΥΜΟ',
        postcode: 'Ταχυδρομικός κώδικας',
        birthdate: 'DATA NAȘTERII',
        buying_date: 'TO_TRANSLATE_RO_date d\'achat',
        date_max_today:'DATA',
        date_input:'DATA',
        phone: 'τηλέφωνο',
        mobile_phone: 'κινητό τηλέφωνο',
        fixed_phone: 'τηλέφωνο'
      },
      custom: {
        birthdate: {
          before: 'Vous devez être majeur'
        },
        date_max_today: {
          date_min:"TO_TRANSLATE_RO_Deze datum kan niet vroeger zijn dan de start van deze bewerking",
        }
      }
    }
  },
  it: {
    suivant: 'TO_TRANSLATE_IT Suivant',
    valider: 'TO_TRANSLATE_IT Valider',
    champ_obligatoire: 'TO_TRANSLATE_IT Champ obligatoire',
    precedent: 'TO_TRANSLATE_IT Précédent',
    merci_renseigner_adresse: 'TO_TRANSLATE_IT Merci de renseigner votre adresse, ou cliquer sur "Je ne trouve pas mon adresse"',
    votre_adresse: 'TO_TRANSLATE_IT Votre Adresse',
    N_rue: 'N°, rue *',
    compl_addresse: "Complément d'adresse",
    ville: "Ville *",
    code_postal: "Code postal *",
    Madame: 'Madame',
    Monsieur: 'Monsieur',
    Numero_identification: 'TO_TRANSLATE_IT_D.U.N.S nummer *',
    trouvepasadresse: 'Vous ne trouvez pas votre adresse ?',
    trouvepasreparateur: 'TO_TRANSLATE_IT_REPARATOR?',
    enseigne_psa: 'TO_TRANSLATE_IT_ENSEIGNE',
    email_reparateur:'TO_TRANSLATE_IT_Email de votre réparateur *',
    VeeValidate: {
      attributes: {
        email: 'TO_TRANSLATE_IT_adresse mail',
        email_confirmation: 'TO_TRANSLATE_IT_confirmation de l\'adresse mail',
        full_name: 'TO_TRANSLATE_IT_nom complet',
        first_name: 'TO_TRANSLATE_IT_prénom',
        last_name: 'TO_TRANSLATE_IT_nom de famille',
        postcode: 'TO_TRANSLATE_IT_code postal',
        birthdate: 'TO_TRANSLATE_IT_date de naissance',
        buying_date: 'TO_TRANSLATE_IT_date d\'achat',
        date_max_today:'TO_TRANSLATE_IT_date',
        date_input:'TO_TRANSLATE_IT_date',
        phone: 'TO_TRANSLATE_IT_numéro de téléphone',
        mobile_phone: 'TO_TRANSLATE_IT_numéro de mobile',
        fixed_phone: 'TO_TRANSLATE_IT_numéro de téléphone fixe'
      },
      custom: {
        birthdate: {
          before: 'TO_TRANSLATE_IT_Vous devez être majeur'
        },
        date_max_today: {
          date_min:"TO_TRANSLATE_IT_Deze datum kan niet vroeger zijn dan de start van deze bewerking",
        },
      }
    }
  },
  pl: {
    suivant: 'Następny',
    valider: 'Zatwierdź',
    champ_obligatoire: 'Wymagane pole',
    blurry_document: 'Ten dokument jest niewyraźny, radzimy wysłać inny obraz, aby uniknąć odrzucenia pliku.',
    precedent: 'Poprzedni',
    merci_renseigner_adresse: 'Wpisz swój adres lub kliknij „Nie mogę znaleźć swojego adresuWpisz swój adres lub kliknij „Nie mogę znaleźć swojego adresu',
    votre_adresse: 'Twój adres',
    N_rue: 'Adres',
    compl_addresse: 'Uzupełnienie adresu',
    Numero_identification: 'Numer identyfikacyjny',
    ville: "Miasto",
    code_postal: "Kod pocztowy",
    Madame: 'Pani.',
    Monsieur: 'Pan.',
    trouvepasadresse: 'Nie możesz znaleźć swojego adresu?',
    trouvepasreparateur: 'TO_TRANSLATE_PL_REPARATOR?',
    email_reparateur:'TO_TRANSLATE_PL_Email de votre réparateur *',
    enseigne_psa: 'TO_TRANSLATE_PL_ENSEIGNE',
    VeeValidate: {
      attributes: {
        email: 'Adres e-mail',
        email_confirmation: 'Potwierdzenie E-mail',
        full_name: 'TO_TRANSLATE_PL nom complet',
        first_name: 'Imię i nazwisko',
        last_name: 'Nazwisko',
        postcode: 'Kod pocztowy',
        birthdate: 'TO_TRANSLATE_PL date de naissance',
        buying_date: 'Data zakupu',
        date_max_today:'Data',
        date_input:'Data',
        phone: 'Telefon ',
        mobile_phone: 'Numer telefonu komórkowego',
        fixed_phone: 'Numer telefonu stacjonarnego'
      },
      custom: {
        birthdate: {
          before: 'TO_TRANSLATE_PL Vous devez être majeur'
        },
        date_max_today: {
          date_min:"Data nie może być wcześniejsza niż początek akcji",
        }
      }
    }
  },
  pt: {
    suivant: 'Próximo',
    valider: 'Validar',
    multiselect_list_empty: 'Comece a dactilografar',
    champ_obligatoire: 'Campo obrigatório',
    blurry_document: 'Este documento parece desfocado, aconselhamos a enviar outra imagem para evitar que o ficheiro seja recusado',
    precedent: 'Anterior',
    merci_renseigner_adresse: ' Introduzca su dirección o haga clic en "No encuentro mi dirección"',
    votre_adresse: 'O seu endereço',
    changez_votre_adresse: 'Altere o seu endereço',
    N_rue: 'Endereço, linha 1',
    compl_addresse: "Endereço adicional",
    Numero_identification: 'TO_TRANSLATE_PL_D.U.N.S nummer',
    ville: "Cidade",
    code_postal: "Código postal",
    Madame: 'Senhora',
    Monsieur: 'Senhor',
    'corrigez les erreurs': 'Por favor, verifique os erros restantes no formulário',
    trouvepasadresse: 'Não consegue encontrar a sua morada?',
    trouvepasreparateur: 'TO_TRANSLATE_PT_REPARATOR?',
    email_reparateur:'TO_TRANSLATE_PT_Email de votre réparateur *',
    enseigne_psa: 'TO_TRANSLATE_PT_ENSEIGNE',
    VeeValidate: {
      attributes: {
        email: 'Email',
        email_confirmation: 'Confirmação de e-mail',
        full_name: 'Nome completo',
        first_name: 'Primeiro nome',
        last_name: 'Sobrenome',
        postcode: 'Código postal',
        birthdate: 'Data de nascimento',
        buying_date: 'Data de compra',
        date_max_today:'Data',
        date_input:'Date',
        phone: 'Telefone',
        mobile_phone: 'número de telefone',
        fixed_phone: 'número de telefone residencial'
      },
      custom: {
        birthdate: {
          before: 'TO_TRANSLATE_PT_MAJOR'
        },
        ean: {
          regex: 'TO_TRANSLATE_PT_MAJOR_EAN'
        },
        email: {
          unique: 'TO_TRANSLATE_PT_MAJOR_UNIQ',
        },
        confirm: {
          required:'Este campo é obrigatório'
        },
        marketing1: {
          required:'Este campo é obrigatório'
        },
        marketing2: {
          required:'Este campo é obrigatório'
        },
        Iban: {
          iban: "Este IBAN é inválido",
          countryiban: "Os IBANs deste país não são aceites"
        },
        date_max_today: {
          date_min:"Esta data não pode ser anterior ao início da operaçãon",
          required:'Este campo é obrigatório'
        }
      }
    }
  }
}

messages['es'] = messages['es-es']
messages['si'] = messages['sl']
messages['en-uk'] =  messages['uk']
messages['en'] =  messages['uk']
messages['fr-fr'] =  messages['fr']
messages['gr'] =  messages['el']

export default {
  mixin: {
    methods: {
      $t(key, locale) {
        if(messages[locale] && messages[locale][key]) {
          return messages[locale][key];
        } else if(messages['fr'] && messages['fr'][key]){
          return messages['fr'][key];
        } else {
          return key;
        }
      },
    }
  },
  ...messages
};